<template>
  <v-card class="pa-2">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-subtitle>
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.firstName"
              label="First name"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.lastName"
              label="Last name"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="profile.companyName"
              label="Company"
              outlined
              disabled
              append-icon="lock"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="register">
            <v-text-field
              v-model="profile.email"
              label="Email"
              outlined
              :rules="emailRules"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.jobTitle"
              label="Job title (optional)"
              outlined
              maxlength="50"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.phoneNumber"
              label="Phone (optional)"
              outlined
              :rules="[$rules.phone]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.password"
              label="Password"
              outlined
              maxlength="50"
              :rules="passwordRules"
              required
              type="password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="profile.passwordConfirm"
              label="Confirm Password"
              outlined
              maxlength="50"
              :rules="passwordConfirmationRules"
              required
              type="password"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <template v-if="!register">
        <v-row>
          <v-col cols="auto">
            <image-edit-badge :saveAction="avatarSaveAction">
              <avatar :avatarUrl="profile.avatarUrl" :size="80" color="primary">
              </avatar>
            </image-edit-badge>
          </v-col>
          <v-col>
            <v-card-title class="primary--text">
              Upload Your Profile Image
            </v-card-title>
            <v-card-subtitle>
              This is optional, but it does help your employer identify you in
              the system
            </v-card-subtitle>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="save" :loading="saving">
        Save &amp; Continue <v-icon class="mr-0">keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ImageEditBadge from "@/components/common/ImageEditBadge";
export default {
  name: "ProfileForm",
  components: {
    "image-edit-badge": ImageEditBadge
  },
  props: {
    register: { type: Boolean, default: false },
    title: { type: String, default: "Complete our survey profile" },
    subtitle: {
      type: String,
      default:
        "You have one survey pending, but you'll need to complete your profile first"
    },
    saveAction: { type: String, default: "profile/saveProfile" },
    avatarSaveAction: { type: String, default: "profile/uploadAvatar" }
  },
  data: () => ({
    valid: true,
    saving: false,
    emailExists: false
  }),
  watch: {
    "profile.email": function(val, oldVal) {
      if (val != oldVal) {
        this.emailExists = false;
      }
    }
  },
  computed: {
    passwordRules() {
      return [
        v => !!v || "Required",
        v => {
          const pattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_.])(?=.{8,})/;
          return (
            !v ||
            pattern.test(v) ||
            "Min. 8 characters with at least one capital letter, a number and a special character (!,@,#,$,%,^,&,*,_,.)."
          );
        }
      ];
    },
    passwordConfirmationRules() {
      return [
        v =>
          !this.profile.password ||
          this.profile.password === v ||
          "Passwords must match"
      ];
    },
    emailRules() {
      let list = [this.$rules.required, this.$rules.email];
      if (
        this.profile.settings &&
        this.profile.settings.domains &&
        this.profile.settings.domains.length > 0
      ) {
        list.push(
          v =>
            this.profile.settings.domains.filter(x => this._.endsWith(v, x))
              .length > 0 || "Email not a valid email for your company"
        );
      }
      list.push(
        () => !this.emailExists || "Email already exists in CoreCounts"
      );
      return list;
    },
    ...mapGetters({
      profile: "profile/profile"
    })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch(this.saveAction, this.profile)
          .then(url => {
            if (url) {
              window.location.href = url;
            }
          })
          .catch(err => {
            if (err && err.emailExists) {
              this.emailExists = true;
              this.$refs.form.validate();
            } else {
              this.$root.$alert(
                "Error Occurred",
                "An error occurred while saving your profile."
              );
            }
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
